import React, { PureComponent } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { LayoutContextProvider } from './LayoutContext';
function generator({ displayName, suffixCls }) {
    return (BasicComponent) => {
        var _a;
        return _a = class Adapter extends PureComponent {
                static get contextType() {
                    return ConfigContext;
                }
                render() {
                    const { prefixCls: customizePrefixCls } = this.props;
                    const { getPrefixCls } = this.context;
                    return (React.createElement(BasicComponent, Object.assign({ prefixCls: getPrefixCls(suffixCls, customizePrefixCls) }, this.props)));
                }
            },
            _a.displayName = displayName,
            _a;
    };
}
function Basic(props) {
    const { prefixCls, className, children, ...others } = props;
    const divCls = classNames(className, prefixCls);
    return (React.createElement("div", Object.assign({ className: divCls }, others), children));
}
class BasicLayout extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = { siders: [] };
    }
    static get contextType() {
        return ConfigContext;
    }
    getContextValue() {
        const { siders } = this.state;
        const { getPrefixCls } = this.context;
        return {
            siderHook: {
                addSider: (id) => {
                    this.setState({
                        siders: [...siders, id],
                    });
                },
                removeSider: (id) => {
                    this.setState({
                        siders: siders.filter(currentId => currentId !== id),
                    });
                },
            },
            getPrefixCls,
        };
    }
    render() {
        const { prefixCls, className, children, hasSider, ...others } = this.props;
        const { siders } = this.state;
        const divCls = classNames(className, prefixCls, {
            [`${prefixCls}-has-sider`]: hasSider || siders.length > 0,
        });
        return (React.createElement(LayoutContextProvider, Object.assign({}, this.getContextValue()),
            React.createElement("div", Object.assign({ className: divCls }, others), children)));
    }
}
BasicLayout.displayName = 'BasicLayout';
const Layout = generator({
    suffixCls: 'layout',
    displayName: 'Layout',
})(BasicLayout);
const Header = generator({
    suffixCls: 'layout-header',
    displayName: 'Header',
})(Basic);
const Footer = generator({
    suffixCls: 'layout-footer',
    displayName: 'Footer',
})(Basic);
const Content = generator({
    suffixCls: 'layout-content',
    displayName: 'Content',
})(Basic);
Layout.Header = Header;
Layout.Footer = Footer;
Layout.Content = Content;
export default Layout;
